import {
  FileAttachment,
  UploadFileWithAttachment,
  FileUploadStatus,
} from 'api/attachments';
import { uid } from 'utils/uid';

export const convertFileAttachmentToUploadFileWithAttachment = (
  data: FileAttachment[],
): UploadFileWithAttachment[] =>
  data.map((d) => ({
    ...d,
    uid: uid(String(d.attachmentId)),
    size: d.sizeInBytes,
    type: 'TYPE',
    attachment: d,
    status: FileUploadStatus.Done,
    thumbUrl: d?.thumbLocation || d?.location,
    url: d?.location,
  }));
